<template>
    <v-layout class="header-menu" row>
        <v-flex xs7 class="hotel-name d-inline-flex">
            <v-menu offset-y class="hotel-list" content-class="hotel-list__content" v-if="selectedHotel != null">
                <template v-slot:activator="{ attrs, on }">
                    <div
                        class="hotel-list__title"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <div class="title-block">
                            <span>{{ selectedHotel.name }}, {{ selectedHotel.address }}</span>
                        </div>
                        <v-img width="28px" height="28px" :src="require('@/assets/icons/arrow_down_icon.svg')" />
                    </div>
                </template>

                <v-list class="hotel-list__list">
                    <v-radio-group
                        v-for="item in hotels"
                        :key="item.uid"
                        link
                        v-model="selectedHotel"
                    >
                        <v-list-item>
                            <v-list-item-content>
                                <v-radio
                                    :label="`${item.name}, ${item.address}`"
                                    :value="item"
                                    :class="{'radio-edit': settings}"
                                />
                                <div class="close-btn ml-2" v-if="settings" @click="openModalAddHotel(item)">
                                    <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/edit_icon.svg')" class="d-inline-flex"/>
                                </div>
                                <div class="close-btn" v-if="settings" @click="openDeleteHotel(item)">
                                    <v-img max-height="18px" :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex"/>
                                </div>
                            </v-list-item-content>
                        </v-list-item>
                    </v-radio-group>
                    <v-flex class="add-hotel-btn mt-8" xs12 v-if="settings">
                        <v-btn class="btn-light-grey main-text" @click="openModalAddHotel()">
                            Добавить новый отель или корпус +
                        </v-btn>
                    </v-flex>
                </v-list>
            </v-menu>
            <v-flex v-if="settings && !this.selectedHotel" class="add-hotel-btn mt-8" xs12>
                <v-btn class="btn-light-grey main-text" @click="openModalAddHotel()">
                    Добавить новый отель или корпус +
                </v-btn>
            </v-flex>
        </v-flex>
        <v-flex class="dashboard">
            <div v-if="showSearch" class="d-inline-flex align-center">
                <v-text-field
                    v-model="searchText"
                    placeholder="Введите номер"
                    class="white-input d-inline-flex ma-0 mr-4"
                    dense
                    hide-details
                    @keyup.enter="searchRoom"
                >
                    <template v-slot:append>
                        <img
                            width="20"
                            height="20"
                            :src="require('@/assets/icons/search_icon.svg')"
                        >
                    </template>
                </v-text-field>
            </div>
            <div
                v-for="(item, index) in menuItems"
                :key="index"
                class="dashboard__icon"
                :class="{ 'active': item == activeItem }"
                @click="setItem(item)"
            >
                <v-img :src="require('@/assets/icons/' + item.icon + '.svg')" />
            </div>
        </v-flex>
        <ModalAddHotel v-model="modalAddHotel" :hotel="editHotel" :close="closeModalAddHotel"></ModalAddHotel>
        <ModalDeleteConfirm
            v-model="modalDeleteHotel"
            :close="closeDeleteHotel"
            :url="`/hotels/hotel-admin/hotels/${deletedHotel.uid}/`"
        >
            <template #deleteTitle>
                Вы действительно хотите <br> удалить отель <br> {{deletedHotel.name}}?
            </template>
        </ModalDeleteConfirm>
    </v-layout>
</template>

<script>
import ModalAddHotel from "@/components/modals/ModalAddHotel";
import ModalDeleteConfirm from "@/components/modals/ModalDeleteConfirm";
import Centrifuge from "centrifuge";
import {eventBus} from "@/main";
import { mapMutations } from 'vuex';

export default {
    name: "HeaderMenu",
    components: {ModalAddHotel, ModalDeleteConfirm},
    props: {
        value: {
            type: String,
        },
        search: {
            type: Function,
            default: () => {},
        },
        edit: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            menu: [
                {
                    icon: "search_icon",
                    active: false,
                    action: "search",
                },
                {
                    icon: "settings_icon",
                    active: false,
                    action: "settings",
                },
                {
                    icon: "logout_icon",
                    active: false,
                    action: "logout",
                },
            ],
            activeItem: null,
            selectedHotel: null,
            editHotel: null,
            deletedHotel: {},
            hotels: [],
            showSearch: false,
            searchText: "",
            modalAddHotel: false,
            modalDeleteHotel: false,
            centrifuge: null,
            reconnect: false,
        };
    },
    created() {
        if (!this.$store.state.canEditStructureHotels || this.$store.state.canEditStructureHotels == "false") {
            this.menu.splice(1, 1);
        }
        if (this.$store.state.accessToken) {
            this.getHotelsList();
        }
        eventBus.$on("hotel", this.setChangeHotelList);
    },
    beforeDestroy() {
        if (this.centrifuge) {
            this.centrifuge.disconnect();
        }
    },
    computed: {
        menuItems() {
            let items = JSON.parse(JSON.stringify(this.menu));
            if (this.showSearch) {
                items.shift();
            }
            return items;
        },
        settings() {
            return this.activeItem && this.activeItem.action == "settings";
        },
    },
    watch: {
        activeItem(val) {
            if (val) {
                if (val.action == "logout") {
                    this.logOut();
                } else if (val.action == "search") {
                    this.showSearch = true;
                } else if (val.action == "settings") {
                    this.showSearch = false;
                    if (this.searchText) {
                        this.searchText = "";
                        this.search();
                    }
                    if (this.selectedHotel) {
                        this.edit(true);
                    }
                }
            } else {
                this.showSearch = false;
                this.edit(false);
            }
        },
        selectedHotel(val) {
            if (val) {
                this.searchText = "";
                this.$store.commit("setTimezone", (val.timezone));
                this.$emit("input", val.uid);
                this.$router.push({name: "hotelpage", query: {hotel: val.uid}}).catch(() => {});
                this.openWebSocket();
            }
        },
    },
    methods: {
        ...mapMutations(['setTimezone']),
        getHotelsList() {
            this.$http.get('/hotels/hotel-admin/hotels/')
                .then((response) => {
                    this.hotels = response.data.results;
                    if (this.hotels && this.hotels.length > 0) {
                        if (this.value) {
                            this.selectedHotel = this.hotels.find((el) => {
                                return el.uid == this.value;
                            });
                        } else {
                            this.selectedHotel = this.hotels[0];
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        logOut() {
            localStorage.removeItem("RobohotelAdminAccessToken");
            this.$router.push( '/');
            this.$router.go( 0);
        },
        setItem(item) {
            if (this.activeItem == item) {
                this.activeItem = null;
            } else {
                this.activeItem = item;
            }
        },
        searchRoom() {
            this.search(this.searchText);
        },
        openModalAddHotel(hotel = null) {
            this.editHotel = hotel;
            this.modalAddHotel = true;
        },
        closeModalAddHotel() {
            this.editHotel = null;
            this.modalAddHotel = false;
        },
        openDeleteHotel(hotel) {
            this.deletedHotel = hotel;
            this.modalDeleteHotel = true;
        },
        closeDeleteHotel() {
            this.modalDeleteHotel = false;
            this.deletedHotel = {};
        },
        setChangeHotelList(data) {
            if (data) {
                if (data.is_delete) {
                    let index = this.hotels.map(hotel => {
                        return hotel.uid
                    }).indexOf(data.hotel.uid);
                    this.hotels.splice(index, 1);
                    if (this.selectedHotel.uid == data.hotel.uid) {
                        this.selectedHotel = this.hotels[0];
                    }
                } else {
                    let index = this.hotels.map(hotel => {
                        return hotel.uid
                    }).indexOf(data.hotel.uid);
                    if (index != -1) {
                        this.hotels[index] = data.hotel;
                    } else {
                        this.hotels.push(data.hotel);
                    }
                }
            }
        },
        openWebSocket() {
            this.centrifuge = new Centrifuge(process.env.VUE_APP_WS_API_URL, {
                retry: 1000,
                maxRetry: 2000,
            });
            const user_access_token = this.$store.state.accessToken;
            const hotel_pk = this.selectedHotel.uid;
            this.centrifuge.setConnectData({
                'user_access_token': user_access_token,
                'hotel_pk': hotel_pk,
            });
            let is_subscribe = false;

            this.centrifuge.on('connect', (ctx) => {
                console.log("connected", ctx);
                if (this.reconnect) {
                    this.reconnect = false;
                    eventBus.$emit("reconnect");
                }
                let hotel_token = ctx.data.hotel_token;

                if (!is_subscribe) {
                    this.centrifuge.subscribe("hotel_update:hotel_" + hotel_token, function (ctx) {
                        if (ctx.data.update_type == "room") {
                            eventBus.$emit("room", {
                                is_delete: ctx.data.is_delete,
                                room: ctx.data.room,
                            });
                        } else if (ctx.data.update_type == "hotel") {
                            eventBus.$emit("hotel", {
                                is_delete: ctx.data.is_delete,
                                hotel: ctx.data.hotel,
                            });
                        }
                    });
                    is_subscribe = true;
                }
            });

            this.centrifuge.on('disconnect', (ctx) => {
                this.reconnect = true;
                console.log("disconnected", ctx);
            });
            this.centrifuge.connect();
        },
    }
}
</script>

<style lang="scss" scoped>
.hotel-list__content.v-menu__content {
    border-radius: 30px !important;
    max-height: calc(100% - 24px);

    &::-webkit-scrollbar {
        display: none;
    }

    .v-list.hotel-list__list {
        padding: 24px;

        .v-input.v-input--selection-controls.v-input--radio-group {
            min-height: 20px;
            padding: 0;
            margin: 0;

            &:not(:last-child) {
                margin-bottom: 12px;
            }

            &::v-deep .v-input__control {
                .v-messages {
                    display: none;
                }
                .v-input__slot {
                    margin: 0;

                    .v-list-item {
                        padding: 0;
                        min-height: 20px;
                        background: #FFFFFF;

                        .v-list-item__content {
                            padding: 0;
                            display: flex;

                            .v-input--selection-controls__input {
                                .v-icon {
                                    background-image: url("../assets/icons/input_icon.svg");
                                    background-position: center center;

                                    &:before,
                                    &:after {
                                        content: none;
                                    }
                                }

                                .v-input--selection-controls__ripple {
                                    color: #ffffff !important;
                                    caret-color: #ffffff !important;
                                }
                            }

                            label.v-label {
                                font-weight: 400;
                                font-size: 16px;
                                line-height: 19px;
                                color: #130F26;
                            }

                            .v-radio {
                                display: inline-flex;

                                &.radio-edit {
                                    max-width: calc(100% - 70px);
                                }
                            }

                            .v-radio.v-item--active .v-input--selection-controls__input .v-icon {
                                background-image: url("../assets/icons/input_active_icon.svg");
                            }
                        }
                    }
                }
            }
        }

        .add-hotel-btn {
            margin: 0 40px;
        }
    }
}
</style>